import { GapValues } from "@/lib/utils/GapValues";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { Box } from "@stenajs-webui/core";
import {
  Tab,
  TabMenu,
  stenaBusinessInvoice,
  stenaBusinessNslh,
  stenaOverview,
} from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router";
import { routeFactory } from "../../RouteFactory";
import { NslhInvoiceTab, listInvoicesTabs } from "./config/tabConfig";
import { PageHeader } from "@/components/page-header/PageHeader";
import { PageHeaderRow } from "@stenajs-webui/panels";

interface Props {
  actionBar?: React.ReactNode;
  breadCrumbs?: React.ReactNode;
  headingText: string;
}

export const NslhPageHeader: React.FC<Props> = ({
  actionBar = null,
  breadCrumbs,
  headingText,
}) => {
  const navigate = useNavigate();
  const { tab: selectedTab } = useParams() as { tab: string };
  return (
    <Box width={"100vw"} position={"sticky"} left={0} zIndex={ZIndex.lowest}>
      <PageHeader
        title={headingText}
        icon={stenaBusinessNslh}
        tabs={
          <TabMenu>
            {listInvoicesTabs.map((tab) => (
              <Fragment key={tab.value}>
                {tab.value === NslhInvoiceTab.overview}
                <Tab
                  data-testid={`tab_${tab.value}`}
                  leftIcon={
                    tab.value === NslhInvoiceTab.overview
                      ? stenaOverview
                      : stenaBusinessInvoice
                  }
                  label={tab.label}
                  selected={
                    (!selectedTab && NslhInvoiceTab.overview === tab.value) ||
                    selectedTab === tab.value
                  }
                  onClick={() =>
                    navigate(
                      routeFactory.noShowLateHandling.followUpTabView(tab.value)
                    )
                  }
                />
              </Fragment>
            ))}
          </TabMenu>
        }
      >
        <PageHeaderRow gap={GapValues.SIXTEEN} height={"54px"}>
          {actionBar}
        </PageHeaderRow>
      </PageHeader>
    </Box>
  );
};
